import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material';

import { OrientationEnum, PaperFormatEnum } from '@e-socna/data-layer';
import { checkIfIsArray } from '@e-socna/utils';
import { EMPTY_ARRAY } from '@e-socna/empty';

import {
  PRINTER_SECTION_CLASSNAME,
  PRINTER_ORIENTATION_LANDSCAPE_CLASSNAME,
  PRINTER_ORIENTATION_PORTRAIT_CLASSNAME,
  PRINTER_FORMAT_A4_CLASSNAME,
  PRINTER_FORMAT_A3_CLASSNAME,
} from './GlobalStyles';
import { HtmlViewer } from './HtmlViewer';

interface Props {
  readonly paperFormat?: PaperFormatEnum;
  readonly html?: string | null;
  readonly orientation?: OrientationEnum;
  readonly sx?: SxProps<Theme>;
}

// MHO: please read
// https://stackoverflow.com/questions/61533780/how-to-use-css-transform-scale-to-fit-child-div-to-parent-div-responsively-i
// https://stackoverflow.com/questions/73267568/how-to-use-getboundingclientrect-with-transform-scale
// https://usehooks.com/useWindowSize/

export const PageViewer = ({
  paperFormat = PaperFormatEnum.A4,
  html,
  orientation = OrientationEnum.Portrait,
  sx,
}: Readonly<Props>) => (
  <Box
    // eslint-disable-next-line react/forbid-component-props
    className={`${PRINTER_SECTION_CLASSNAME} ${
      orientation === OrientationEnum.Portrait
        ? PRINTER_ORIENTATION_PORTRAIT_CLASSNAME
        : PRINTER_ORIENTATION_LANDSCAPE_CLASSNAME
    } ${
      paperFormat === PaperFormatEnum.A3
        ? PRINTER_FORMAT_A3_CLASSNAME
        : PRINTER_FORMAT_A4_CLASSNAME
    }`}
    sx={[
      ...(!sx ? EMPTY_ARRAY : checkIfIsArray(sx) ? sx : [sx]),
      {
        ...{
          maxWidth: `100%!important`,
          width: `100%!important`,
          minWidth: `100%!important`,
        },
      },
    ]}
  >
    <HtmlViewer html={html} />
  </Box>
);
